import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ProductContentWrapper from '../Product/Block/ProductContentWrapper';
import Configurator from '../AutomationConfigurator/AutomationConfigurator';
import H1 from '../Heading/H1';
import './Page.css';

export default function AutomationConfigurator(props) {
  const [expandedMenuPath, setExpandedMenuPath] = useState(undefined);
  function expandPathHandler(togglePath) {
    if (expandedMenuPath && expandedMenuPath.indexOf(togglePath) === 0) {
      const pathArray = togglePath.split('|');
      pathArray.pop();
      setExpandedMenuPath(pathArray.join('|'));
    } else {
      setExpandedMenuPath(togglePath);
    }
  }
  return (
    <ProductContentWrapper
      locale={props.locale}
      setLocale={props.setLocale}
      services={props.services}
      dataStorage={props.dataStorage}
      setDataStorage={props.setDataStorage}
      expandedMenuPath={expandedMenuPath}
      setExpandedMenuPath={expandPathHandler}
    >
      <H1 configService={props.services.configService} />
      <Configurator
        automationProducts={props.services.automationConfiguratorService
          .getAutomationConfiguratorProducts(props.dataStorage)}
        locale={props.locale}
        services={props.services}
        dataStorage={props.dataStorage}
      />
    </ProductContentWrapper>
  );
}

AutomationConfigurator.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  dataStorage: PropTypes.objectOf(PropTypes.any).isRequired,
  setDataStorage: PropTypes.func.isRequired,
};
